import {
  CLEAR_FILTERS,
  DELETE_FILTER,
  DELETE_FILTER_ITEM,
  REPLACE_FILTERS,
  SET_APPLIED_FILTER,
  SET_CURRENCY_ID,
  SET_FILTER,
  SET_FILTER_AND_APPLY,

  GET_ALERTS_TOTAL,
  GET_ALERTS_TOTAL_SUCCESS,
  GET_ALERTS_TOTAL_FAIL,

  GET_ALERTS_TOTAL_UNVIEWED,
  GET_ALERTS_TOTAL_UNVIEWED_SUCCESS,
  GET_ALERTS_TOTAL_UNVIEWED_FAIL,

  SEND_COMMENT,
  SEND_COMMENT_SUCCESS,
  SEND_COMMENT_FAIL,
} from "../actions/monitoring";

const initialState = {
  filters: {},
  currencyId: 1,
  appliedFilters: {},
  total: 0,
  totalUnviewed: 0,

  isLoadingAlertsTotal: false,
  isLoadingAlertsTotalUnviewed: false,

  isLoadingSendComment: false,
};

export default function monitoring(state = initialState, action = {}) {
  switch (action.type) {

    case GET_ALERTS_TOTAL:
      return {
        ...state,
        isLoadingAlertsTotal: true
      }

    case GET_ALERTS_TOTAL_SUCCESS:
      return {
        ...state,
        isLoadingAlertsTotal: false,
        total: +action.response.count,
      }

    case GET_ALERTS_TOTAL_FAIL:
      return {
        ...state,
        isLoadingAlertsTotal: false,
      }

    case GET_ALERTS_TOTAL_UNVIEWED:
      return {
        ...state,
        isLoadingAlertsTotalUnviewed: true
      }

    case GET_ALERTS_TOTAL_UNVIEWED_SUCCESS:
      return {
        ...state,
        isLoadingAlertsTotalUnviewed: false,
        totalUnviewed: +action.response.count,
      }

    case GET_ALERTS_TOTAL_UNVIEWED_FAIL:
      return {
        ...state,
        isLoadingAlertsTotalUnviewed: false,
      }

    case CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          ...initialState.filters,
          ...(action.filters ?? {})
        },
        appliedFilters: {
          ...initialState.appliedFilters,
          ...(action.filters ?? {})
        }
      }

    case SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]: action.value
        }
      }

    case SET_FILTER_AND_APPLY:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filter,
        },
        appliedFilters: {
          ...state.filters,
          ...action.filter
        }
      }

    case DELETE_FILTER:
      const afterDeleteFilters = Object.keys(state.appliedFilters)
        .filter(key => key !== action.name)
        .reduce((prev, next) => ({
          ...prev,
          [next]: state.appliedFilters[next]
        }), {})
      return {
        ...state,
        filters: afterDeleteFilters,
        appliedFilters: afterDeleteFilters,
      }

    case DELETE_FILTER_ITEM:
      const afterDeleteFilterItem = state.filters[action.name].filter(value => value !== action.value);
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.name]: afterDeleteFilterItem
        },
        appliedFilters: {
          ...state.appliedFilters,
          [action.name]: afterDeleteFilterItem
        }
      }

    case SET_APPLIED_FILTER:
      return {
        ...state,
        appliedFilters: {
          ...state.filters
        }
      }

    case REPLACE_FILTERS:
      return {
        ...state,
        filters: {
          ...action.filters
        },
        appliedFilters: {
          ...action.filters
        }
      }

    case SET_CURRENCY_ID:
      return {
        ...state,
        currencyId: +action.value
      }

    case SEND_COMMENT:
      return {
        ...state,
        isLoadingSendComment: true
      }

    case SEND_COMMENT_SUCCESS:
      return {
        ...state,
        isLoadingSendComment: false
      }

    case SEND_COMMENT_FAIL:
      return {
        ...state,
        isLoadingSendComment: false
      }

    default:
      return state;
  }
}
